'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import { RATING_AGENCY_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import useCorporateTopCompany from './useCorporateTopCompany';

type TopRatingAgenciesContextType = ReturnType<typeof useCorporateTopCompany>;

export const CorporateTopRatingAgenciesContext = createContext<TopRatingAgenciesContextType>(null);

export const useCorporateTopRatingAgenciesContext = () => {
  const context = useContext(CorporateTopRatingAgenciesContext);
  if (!context) {
    throw new Error('useCorporateTopRatingAgenciesContext must be used within the CorporateTopRatingAgenciesContext');
  }
  return context;
};

const CorporateTopRatingAgencyContextProvider = ({ children }: PropsWithChildren) => (
  <CorporateTopRatingAgenciesContext.Provider value={ useCorporateTopCompany({
    serverData: null,
    companyRole: RATING_AGENCY_NAME,
  }) }
  >
    { children }
  </CorporateTopRatingAgenciesContext.Provider>
);

export default CorporateTopRatingAgencyContextProvider;
